import {DigitalDocumentTypeEnum} from '@/services/api-clients';

const forceReceivedAllowedDigitalDocumentTypes = [DigitalDocumentTypeEnum.ReceivingProtocol, DigitalDocumentTypeEnum.BikeReceivingProtocol];

export function digitalDocumentTypeIconFilter(type: DigitalDocumentTypeEnum, isForcedReceive: boolean = false) {
  if (forceReceivedAllowedDigitalDocumentTypes.includes(type) && isForcedReceive) return 'mdi-account-arrow-left';

  switch (type) {
    case DigitalDocumentTypeEnum.LeaseAgreement: return 'mdi-car';
    case DigitalDocumentTypeEnum.LoanAgreement: return 'mdi-moped';
    case DigitalDocumentTypeEnum.TransferProtocol: return 'mdi-car-arrow-right';
    case DigitalDocumentTypeEnum.ReceivingProtocol: return 'mdi-car-arrow-left';
    case DigitalDocumentTypeEnum.PromissoryNote: return 'mdi-scale-unbalanced';
    case DigitalDocumentTypeEnum.DeclarationLackOfSII: return 'mdi-office-building-minus';
    case DigitalDocumentTypeEnum.ContractOfMandateDriver: return 'mdi-badge-account';
    case DigitalDocumentTypeEnum.ContractOfMandateCourier: return 'mdi-file-sign';
    case DigitalDocumentTypeEnum.StudentStatusConfirmation: return 'mdi-account-school';
    case DigitalDocumentTypeEnum.BikeTransferProtocol: return 'mdi-car-arrow-right';
    case DigitalDocumentTypeEnum.BikeReceivingProtocol: return 'mdi-car-arrow-left';
    case DigitalDocumentTypeEnum.GeneralProtocol: return 'mdi-file-document';
    case DigitalDocumentTypeEnum.CashRegisterReceipt: return 'mdi-cash-register';
    case DigitalDocumentTypeEnum.CashRegisterDisbursement: return 'mdi-cash-fast';
    default: return '';
  }
}
